// extracted by mini-css-extract-plugin
module.exports = {"PanelHeading":"nn_a pz_nt pz_iv pz_oj","PanelHeading__title":"nn_b pz_rf pz_qt pz_so pz_mz pz_cz pz_ru pz_ta pz_ro"};